import Rater from 'vux/src/components/rater/index.vue'


export default {
name: 'evaluate',
components: {
Rater,
},
data () {
return {
list: [],
postData: []
}
},
methods: {
getCommodityInfo () {
this.$request.post('/comment/listspu',{
orderId: this.$route.query.orderId
}).then(data => {
if(data.code == 0){
this.list = [...data.obj]
this.list.forEach((item, index) => {
item.stars = 1
item.comment = ''
})
console.log(JSON.parse(JSON.stringify(this.list)))
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
comment () {
















for(let i=0; i<this.list.length; i++){
let obj = {};
obj.token = this.$token;
obj.orderId = this.$route.query.orderId;
obj.spuId = this.list[i].spuId;
obj.stars = this.list[i].stars;
obj.comment = this.list[i].comment;
if(this.$trim(this.list[i].comment) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请填写评价'
})
return false;
}
this.postData.push(obj)
}

this.$request.post('/comment/add',this.postData).then(data => {
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '评论成功',
time: 1200
})
setTimeout(() => {
this.$router.push({
path: '/myOrder'
})
}, 1200);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
created () {
this.getCommodityInfo()
},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/evaluate/script.js